<div class="flex-container-column-center height-100 bg-auth-accent">
	<div class="width-100 flex-container-row-nowrap justify-content-space-between box-sizing-border-box">
		<button class="button-reset btn--text padding-16px color-light-gray-on-accent" (click)="cancel()">
			<i aria-hidden="true" class="fa fa-arrow-left"></i>
		</button>
		<ic-change-language class="margin-top-4px margin-right-8px color-light-gray-on-accent" />
	</div>
	<p class="text-align-center color-text margin-top-auto" data-test="problem-message">
		{{ labelKey() | translate }}
	</p>
	<input type="submit" value="{{ 'auth.signin' | translate }}" (click)="submit()" />
	<div
		class="width-100 text-align-center font-size-0-8rem color-light-gray-on-accent margin-top-auto margin-bottom-1rem"
	>
		{{ "settings.version" | translate }} {{ appVersion }}
	</div>
</div>
